import { Sun } from 'lucide-react';

interface WeatherCardProps {
  province: string;
  isDemoMode: boolean;
}

export function WeatherCard({ province, isDemoMode }: WeatherCardProps) {
  // Weather data - conditional based on demo mode
  const weatherData = isDemoMode ? {
    // Demo mode: use mock weather data
    temperature: 34,
    humidity: 60,
    condition: 'sunny'
  } : {
    // Production mode: TODO - fetch real weather data from API
    // For now, fallback to mock data
    temperature: 34,
    humidity: 60,
    condition: 'sunny'
  };

  return (
    <div className="bg-white/90 backdrop-blur-sm rounded-md shadow-sm border border-light-grey p-2 m-2">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 bg-gradient-to-br from-amber-400 to-orange-500 rounded-md flex items-center justify-center">
          <Sun className="w-5 h-5 text-white" />
        </div>
        <div>
          <div className="text-[9px] text-dark-grey">{province === 'All' ? 'Thailand' : `${province}, Thailand`}</div>
          <div className="flex items-baseline gap-1.5">
            <span className="text-base font-bold text-black">{weatherData.temperature}°C</span>
            <span className="text-[10px] text-dark-grey">RH {weatherData.humidity}%</span>
          </div>
        </div>
      </div>
    </div>
  );
}